export default {
  // list
  'crm_customer_car.column.customerId': '客户ID',
  'crm_customer_car.column.carNo': '车牌号',
  'crm_customer_car.column.contactId': '司机',
  'crm_customer_car.column.enableFlag': '是否启用',
  'crm_customer_car.column.createBy': '创建人',
  'crm_customer_car.column.updateBy': '更新人',
  'crm_customer_car.column.createTime': '创建时间',
  'crm_customer_car.column.updateTime': '更新时间',
  'crm_customer_car.column.dataSource': '数据来源',
  'crm_customer_car.column.remark': '备注',
  'crm_customer_car.column.status': '状态',
  // edit
  'crm_customer_car.edit.title': '编辑客户的车',
  'crm_customer_car.add.title': '新增客户的车',
  'crm_customer_car.edit.success': '编辑成功',
  'crm_customer_car.add.success': '新增成功',
  'crm_customer_car.form.carNo.required': '车牌号不能为空',
  'crm_customer_car.form.contactId.required': '司机不能为空',
  'crm_customer_car.form.enableFlag.required': '是否启用不能为空',
  'crm_customer_car.form.carNo': '车牌号',
  'crm_customer_car.form.carNo.placeholder': '请输入车牌号',
  'crm_customer_car.form.contactId': '司机',
  'crm_customer_car.form.contactId.placeholder': '请输入司机',
  'crm_customer_car.form.enableFlag': '是否启用',
  'crm_customer_car.form.enableFlag.placeholder': '请输入是否启用',
}
